"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cartObject = void 0;
const productAttributes = `
    name
    value
`;
const warrantyDetails = `
    id
    quantity
    planId
    price
    term
    title
    product
`;
const addressObject = `
    firstname
    lastname
    street
    city
    region {
        code
        label
    }
    country {
        code
        label
    }
    postcode
    telephone
`;
const assetObject = `
    folder
    filename
`;
const itemObject = `
    id
    name
    sku
    quantity
    productCode
    genericName
    category
    subcategory
    deliveryType
    productUrl
    variantUrl
    inStock
    magentoProductType
    bundleOptions {
        id
        value
        quantity
    }
    price
    mrc
    discount
    discounts {
        label
        amount
    }
    thumbnail
    warranty {
        ${warrantyDetails}
    }
    productAttributes {
        ${productAttributes}
    }
    assets {
        ${assetObject}
    }
    leadToken
`;
const cartObject = `
    cartId
    couponCode
    discount
    hasMattressRemoval
    mrc
    subtotal
    total
    totalItems
    tax {
        amount
    }
    priceDiscounts {
        label
        amount
    }
    items {
        ${itemObject}
    }
    shippingAddress {
        ${addressObject}
    }
    billingAddress {
        ${addressObject}
    }
    email
`;
exports.cartObject = cartObject;
//# sourceMappingURL=typedefs.js.map